import script from "./AdminView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminView.vue?vue&type=script&lang=ts&setup=true"

import "./AdminView.vue?vue&type=style&index=0&id=f31f08f6&lang=scss"

const __exports__ = script;

export default __exports__